import styled from 'styled-components'

export const ModalAlert = styled.div`
  .modal-alert {
    margin-top: 15px;
    font-size: 17px;
    color: ${({ theme }) => theme.cor41} !important;
  }

  .mantine-Group-root {
    justify-content: center !important;
  }
`

export const IconeWrapper = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 10px;

  p {
    color: ${({ theme }) => theme.cor9};
    font-weight: 600;
    font-size: 20px;
  }
`

export const Img = styled.img`
  width: 34px;
  height: 34px;
`

export const Mensagem = styled.div`
  color: ${({ theme }) => theme.designSystem.text.title};
  font-size: 16px;
  text-align: center;

  p {
    margin: 0;
  }
`

export const AlertPlanoContainer = styled.div`
  span {
    font-family: RobotoRegular !important;
    font-size: 16px;
  }
`

export const AlertaReposicaoWrapper = styled.div`
  display: grid;
  gap: 16px;
`
